<template>
    <div class="app">
        <SignInPC v-if="isPC" />
        <SignInH5 v-else />
    </div>
</template>
<script>
    import SignInH5 from '../components/h5';
    import SignInPC from '../components/pc';
    import { enableAppShare } from '../../../common/js/APP/share';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC
        },
        data() {
            return {};
        },
        mounted() {
            enableAppShare({
                title: '喊你免费领礼品啦～',
                desc: '6天礼品狂送，快来点击领取>>>',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20220415/1649990517124.png'
            });
        }
    };
</script>
<style lang="less" scoped>
    .app {
        overflow-x: hidden;
    }
</style>